import {
  Sparkles,
  Scissors,
  ShoppingBasket,
  Utensils,
  Soup,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

const cases = [
  {
    icon: Sparkles,
    business: "Institut de beauté",
    scenario:
      "Une cliente termine son soin, sa carte se tamponne automatiquement au règlement — sans qu'aucune vendeuse n'ait à y penser.",
  },
  {
    icon: Scissors,
    business: "Salon de coiffure",
    scenario:
      "Chaque coupe ajoute un tampon à sa carte de fidélité. Quand le client repasse à proximité, une offre lui est envoyée automatiquement sur son écran de verrouillage.",
  },
  {
    icon: ShoppingBasket,
    business: "Épicerie de quartier",
    scenario:
      "Chaque passage en caisse ajoute un tampon, sans que le commerçant ait à demander le numéro de téléphone à la main. La carte reste dans le portefeuille numérique du client, prête au prochain passage.",
  },
  {
    icon: Utensils,
    business: "Kebab / restauration rapide",
    scenario:
      "Un client régulier approche l'heure du déjeuner : une notification géolocalisée lui rappelle l'offre du jour, avant même qu'il ait choisi où manger.",
  },
  {
    icon: Soup,
    business: "Buffet à volonté",
    scenario:
      "Après 8 passages, le repas est offert — suivi automatiquement, sans carnet de tampons en papier à tamponner ou à perdre.",
  },
];

export function UseCases() {
  return (
    <section id="temoignages" className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Cas d'usage</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Pensé pour votre commerce
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Wara Cards est conçu pour les commerces de proximité — instituts, salons,
            épiceries, restauration rapide. Voici à quoi ça ressemble au quotidien.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cases.map((c, i) => (
            <Reveal key={c.business} delay={(i % 3) * 0.08}>
              <div className="flex h-full flex-col rounded-2xl border border-line bg-white p-6 shadow-card">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-cream-deep text-ink">
                  <c.icon size={20} />
                </div>
                <p className="mt-4 text-sm font-bold text-ink">{c.business}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-soft">
                  {c.scenario}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-10 text-center">
          <p className="text-sm text-ink-soft">
            Wara Cards est en phase de lancement — vous seriez parmi les premiers
            commerçants à l'utiliser.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
